import { useCallback, useEffect, useMemo, useState, type ReactNode } from "react";
import { api } from "./api";
import { SessionContext } from "./session-context";
import type { Session } from "./types";

export function SessionProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    try {
      const response = await api<{ data: Session }>("/api/session");
      setSession(response.data);
    } catch {
      setSession(null);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    let active = true;
    void api<{ data: Session }>("/api/session")
      .then((response) => {
        if (active) setSession(response.data);
      })
      .catch(() => {
        if (active) setSession(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);
  const signOut = useCallback(async () => {
    await api("/api/auth/sign-out", { method: "POST", body: JSON.stringify({}) });
    setSession(null);
  }, []);
  const value = useMemo(
    () => ({ session, loading, refresh, signOut }),
    [session, loading, refresh, signOut],
  );
  return <SessionContext value={value}>{children}</SessionContext>;
}
